<div class="footer">
    <div class="footer__image">
        <a class="" href="#">
            <img src="../../../../assets/img/idb_h_blanc.png" class="footer-img" />
        </a>
    </div>
    <button
        mat-mini-fab
        color="primary"
        class="go-back-btn"
        *ngIf="showBackBtn()"
        (click)="goBackBtn()"
        [ngClass]="{ 'no-alphabetical': !isAlphabeticalView() }"
    >
        <mat-icon>keyboard_backspace</mat-icon>{{ labels.goBack | translate }}
    </button>
</div>
